module.exports = "<app-header></app-header>\r\n<app-sidebar></app-sidebar>\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>\r\n"